import createHistory from 'history/createBrowserHistory'

const history = createHistory();
history.initLength = history.length;
export default history;
